import React, { ReactNode, useCallback, useEffect, useState } from 'react';

interface Props {
  header: ReactNode;
  onClick: (value: any) => void;
  ratingValue: number;
  disabled?: boolean;
}

export const InvoiceRating: React.FC<Props> = ({ onClick, header, ratingValue, disabled }) => {
  const [selectedIndex, setSelectedIndex] = useState(ratingValue > 0 ? ratingValue : 0);

  const handleRatingChange = useCallback(
    (newRatingValue) => {
      setSelectedIndex(newRatingValue);
      onClick(newRatingValue);
    },
    [onClick, setSelectedIndex],
  );

  const handleClick = (e) => {
    const currentButton = e.currentTarget;
    const newRatingIndex = parseInt(currentButton.value, 10);

    handleRatingChange(newRatingIndex === selectedIndex ? 0 : newRatingIndex);
  };

  useEffect(() => {
    // reset selected index if we end up disabled
    if (disabled) {
      handleRatingChange(0);
    }
  }, [disabled, handleRatingChange]);

  return (
    <div>
      <div>{header}</div>
      <div className="mt-2 inline-flex flex-col mb-4">
        <div className="btn-group mt-1 mb-3">
          {[1, 2, 3, 4, 5].map((count) => (
            <button
              value={count}
              key={count}
              onClick={(e) => {
                handleClick(e);
              }}
              className={`disabled:bg-gray-200 disabled:text-gray-400 rounded-lg font-extrabold min-w-10 w-10 h-10 focus:outline-none text-base mr-8 last:mr-0
                ${
                  !disabled
                    ? selectedIndex === count
                      ? 'bg-blue-400 text-white'
                      : 'bg-gray-300 text-gray-800'
                    : ''
                }`}
              disabled={disabled}
            >
              {count}
            </button>
          ))}
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600 font-medium text-xs w-16 text-left">
            Strongly Disagree
          </span>
          <span className="text-gray-600 font-medium text-xs w-16 text-center">Neutral</span>
          <span className="text-gray-600 font-medium text-xs w-16 text-right">Strongly Agree</span>
        </div>
      </div>
    </div>
  );
};
